module.exports = __webpack_public_path__ + "resources/img/img_codesign1_en.3a6dcdb3c8236032a43dcd79b85058ec.png";